export const META_PIXEL_ID =
  process.env.GATSBY_META_PIXEL_ID || "1006390778838156";

export const META_PIXEL_ENABLED = Boolean(META_PIXEL_ID);

const PRE_REGISTRATION_PARAMS = {
  content_name: "핑거프로스튜디오 사전 신청",
  content_category: "pre_registration",
};

export const META_PIXEL_EVENTS = {
  pageView: {
    eventName: "PageView",
    type: "standard",
    description: "모든 페이지 방문",
  },
  preRegistrationView: {
    eventName: "ViewContent",
    type: "standard",
    description: "사전 신청 페이지 방문",
    params: PRE_REGISTRATION_PARAMS,
  },
  preRegistrationStart: {
    eventName: "PreRegistrationStart",
    type: "custom",
    description: "사전 신청 폼 입력 시작",
    params: {
      ...PRE_REGISTRATION_PARAMS,
      lead_type: "pre_application",
    },
  },
  preRegistrationLead: {
    eventName: "Lead",
    type: "standard",
    description: "사전 신청 제출 완료",
    params: {
      ...PRE_REGISTRATION_PARAMS,
      lead_type: "pre_application",
    },
  },
};

const canTrackMetaPixel = () =>
  typeof window !== "undefined" &&
  META_PIXEL_ENABLED &&
  typeof window.fbq === "function";

export const trackMetaPixel = (eventName, params = {}) => {
  if (!canTrackMetaPixel()) return;
  window.fbq("track", eventName, params);
};

export const trackMetaPixelCustom = (eventName, params = {}) => {
  if (!canTrackMetaPixel()) return;
  window.fbq("trackCustom", eventName, params);
};

export const trackMetaPageView = () => {
  trackMetaPixel(META_PIXEL_EVENTS.pageView.eventName);
};

export const trackPreRegistrationView = () => {
  trackMetaPixel(
    META_PIXEL_EVENTS.preRegistrationView.eventName,
    META_PIXEL_EVENTS.preRegistrationView.params
  );
};

export const trackPreRegistrationStart = () => {
  trackMetaPixelCustom(
    META_PIXEL_EVENTS.preRegistrationStart.eventName,
    META_PIXEL_EVENTS.preRegistrationStart.params
  );
};

export const trackPreRegistrationLead = (params = {}) => {
  trackMetaPixel(META_PIXEL_EVENTS.preRegistrationLead.eventName, {
    ...META_PIXEL_EVENTS.preRegistrationLead.params,
    ...params,
  });
};
